import React from "react";
import { Link, NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { LogOut, Home, Building2, Inbox } from "lucide-react";
import { Button } from "../../components/ui/button";

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();

  if (loading)
    return (
      <div className="pt-40 text-center text-[#A3A3A3]" data-testid="admin-loading">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;

  const linkCls = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-3 text-sm border-l-2 transition-colors ${
      isActive
        ? "border-[#D4AF37] text-[#F5F5DC] bg-[#1C1C1E]"
        : "border-transparent text-[#A3A3A3] hover:text-[#F5F5DC]"
    }`;

  return (
    <div className="min-h-screen pt-20" data-testid="admin-layout">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-12 gap-8">
        <aside className="md:col-span-3 md:sticky md:top-24 md:self-start border border-[#F5F5DC]/10 bg-[#121212]/50 backdrop-blur-sm">
          <div className="px-4 py-6 border-b border-[#F5F5DC]/10">
            <p className="overline">Signed in as</p>
            <p className="text-sm mt-1 truncate">{user.email}</p>
          </div>
          <nav className="py-2">
            <NavLink to="/admin" end className={linkCls} data-testid="admin-nav-dashboard">
              <Home size={16} /> Dashboard
            </NavLink>
            <NavLink to="/admin/properties" className={linkCls} data-testid="admin-nav-properties">
              <Building2 size={16} /> Properties
            </NavLink>
            <NavLink to="/admin/inquiries" className={linkCls} data-testid="admin-nav-inquiries">
              <Inbox size={16} /> Inquiries
            </NavLink>
          </nav>
          <div className="px-4 py-4 border-t border-[#F5F5DC]/10 space-y-2">
            <Link to="/" className="block text-xs text-[#A3A3A3] hover:text-[#D4AF37]">
              ← View public site
            </Link>
            <Button
              onClick={() => {
                logout();
                nav("/admin/login");
              }}
              data-testid="admin-logout"
              variant="ghost"
              className="w-full justify-start text-xs text-[#A3A3A3] hover:text-[#FF453A] px-0"
            >
              <LogOut size={14} className="mr-2" /> Sign out
            </Button>
          </div>
        </aside>
        <main className="md:col-span-9 pb-24">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
